/**
 * Exode Naturel — Product Page JavaScript (live site patterns)
 */
(function () {
  'use strict';

  const SELECTORS = {
    productForm: '[data-exode-product-form]',
    gallery: '[data-exode-gallery]',
    variantPicker: '[data-exode-variant-picker]',
    stickyAtc: '[data-exode-sticky-atc]',
    price: '[data-exode-price]',
    comparePrice: '[data-exode-compare-price]',
    savingsBadge: '[data-exode-savings]',
    variantInput: '[data-exode-variant-id]',
    stickyPrice: '[data-exode-sticky-price]',
    stickyBtnPrice: '[data-exode-sticky-btn-price]',
    stickyBtn: '[data-exode-sticky-btn]',
    stickyVariant: '[data-exode-sticky-variant]',
    stickyQty: '[data-exode-sticky-qty]',
  };

  function getAddToCartButton(form, submitter) {
    if (submitter?.matches?.('[data-exode-add-to-cart]')) return submitter;
    const internal = form.querySelector('[data-exode-add-to-cart]');
    if (internal) return internal;
    if (form.id) {
      return document.querySelector(`[data-exode-add-to-cart][form="${form.id}"]`);
    }
    return null;
  }

  function formatMoney(cents, format, formatted) {
    if (formatted) return formatted;
    if (!format) return (cents / 100).toFixed(2);
    const value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','));
  }

  /* Gallery — mobile slider + desktop main image with thumbnail grid */
  function initGallery(container) {
    const track = container.querySelector('[data-exode-gallery-track]');
    const slides = container.querySelectorAll('.exode-gallery__slide');
    const thumbs = container.querySelectorAll('.exode-gallery__thumb');
    const thumbsEl = container.querySelector('[data-exode-thumbs]');

    let index = 0;

    function goTo(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      if (track) track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      thumbs.forEach((t, n) => {
        t.classList.toggle('is-active', n === index);
        t.setAttribute('aria-selected', n === index ? 'true' : 'false');
        if (n === index) t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      const thumbPrev = container.querySelector('[data-exode-thumb-prev]');
      const thumbNext = container.querySelector('[data-exode-thumb-next]');
      if (thumbPrev) thumbPrev.disabled = index <= 0;
      if (thumbNext) thumbNext.disabled = index >= slides.length - 1;
    }

    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));

    if (track && slides.length > 1) {
      let startX = 0;
      track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) goTo(dx < 0 ? index + 1 : index - 1);
      }, { passive: true });
    }

    const thumbPrev = container.querySelector('[data-exode-thumb-prev]');
    const thumbNext = container.querySelector('[data-exode-thumb-next]');
    if (thumbPrev) {
      thumbPrev.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goTo(index - 1);
      });
    }
    if (thumbNext) {
      thumbNext.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goTo(index + 1);
      });
    }

    goTo(0);
  }

  function initVariantPicker(container, productData) {
    const form = document.querySelector(SELECTORS.productForm);
    if (!form || !productData?.variants) return;

    const variantInput = form.querySelector(SELECTORS.variantInput);
    const priceEl = document.querySelector(SELECTORS.price);
    const compareEl = document.querySelector(SELECTORS.comparePrice);
    const savingsEl = document.querySelector(SELECTORS.savingsBadge);
    const stickyPrice = document.querySelector(SELECTORS.stickyPrice);
    const stickyBtnPrice = document.querySelector(SELECTORS.stickyBtnPrice);
    const stickyVariant = document.querySelector(SELECTORS.stickyVariant);
    const addToCartBtn = getAddToCartButton(form);
    const moneyFormat = productData.money_format;
    const options = container.querySelectorAll('[data-exode-option]');

    function getSelectedOptions() {
      const selected = [];
      options.forEach((fs) => {
        const checked = fs.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      return selected;
    }

    function findVariant(selected) {
      return productData.variants.find((v) => v.options.every((o, i) => o === selected[i]));
    }

    function updateVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;

      const price = formatMoney(variant.price, moneyFormat, variant.price_formatted);
      if (priceEl) priceEl.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyBtnPrice) stickyBtnPrice.textContent = price;
      if (stickyVariant) stickyVariant.value = String(variant.id);

      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price, moneyFormat, variant.compare_at_price_formatted);
          compareEl.classList.remove('exode-hidden');
        } else compareEl.classList.add('exode-hidden');
      }

      if (savingsEl) {
        if (variant.compare_at_price > variant.price) {
          savingsEl.textContent = `-${Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)}%`;
          savingsEl.classList.remove('exode-hidden');
        } else savingsEl.classList.add('exode-hidden');
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        const label = addToCartBtn.querySelector('span') || addToCartBtn;
        label.textContent = variant.available ? addToCartBtn.dataset.labelAdd : addToCartBtn.dataset.labelSoldOut;
      }

      const stickyBtn = document.querySelector(SELECTORS.stickyBtn);
      if (stickyBtn) stickyBtn.disabled = !variant.available;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    options.forEach((fs) => {
      fs.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.addEventListener('change', () => {
          const v = findVariant(getSelectedOptions());
          if (v) updateVariant(v);
        });
      });
    });

    if (stickyVariant) {
      stickyVariant.addEventListener('change', () => {
        const v = productData.variants.find((x) => String(x.id) === stickyVariant.value);
        if (v) updateVariant(v);
      });
    }

    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) {
      const v = productData.variants.find((x) => String(x.id) === urlVariant);
      if (v) {
        v.options.forEach((opt, i) => {
          const fs = options[i];
          const input = fs?.querySelector(`input[value="${CSS.escape(opt)}"]`);
          if (input) input.checked = true;
        });
        updateVariant(v);
      }
    }
  }

  function initQuantity(container) {
    const input = container.querySelector('.exode-quantity__input, [data-exode-sticky-qty]');
    const minus = container.querySelector('[data-exode-qty-minus]');
    const plus = container.querySelector('[data-exode-qty-plus]');
    if (!input) return;
    const min = parseInt(input.min, 10) || 1;
    const max = input.max ? parseInt(input.max, 10) : null;
    const set = (v) => {
      let n = Math.max(min, v);
      if (max) n = Math.min(max, n);
      input.value = n;
      const mainQty = document.querySelector('.exode-product-form [name="quantity"]');
      if (mainQty && input.hasAttribute('data-exode-sticky-qty')) mainQty.value = n;
    };
    if (minus) minus.addEventListener('click', () => set(parseInt(input.value, 10) - 1));
    if (plus) plus.addEventListener('click', () => set(parseInt(input.value, 10) + 1));
  }

  function initCollapsibleAccordions(container) {
    container.querySelectorAll('.exode-collapsible-accordion__item').forEach((item) => {
      const summary = item.querySelector('.exode-collapsible-accordion__summary');
      if (!summary) return;
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = item.hasAttribute('open');
        container.querySelectorAll('.exode-collapsible-accordion__item').forEach((other) => {
          other.removeAttribute('open');
        });
        if (!isOpen) item.setAttribute('open', 'open');
      });
    });
  }

  function initUpsellFetch() {
    document.querySelectorAll('[data-exode-upsell-fetch]').forEach((container) => {
      if (container.dataset.loaded === 'true') return;
      const url = container.dataset.url;
      if (!url) return;

      fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const track = container.querySelector('[data-exode-upsell-track]');
          const newTrack = doc.querySelector('[data-exode-upsell-track]');
          if (!track || !newTrack?.querySelector('.exode-upsell-card')) {
            container.remove();
            return;
          }
          track.innerHTML = newTrack.innerHTML;
          container.hidden = false;
          container.dataset.loaded = 'true';
          initUpsell(container);
        })
        .catch(() => container.remove());
    });
  }

  function initUpsell(container) {
    const track = container.querySelector('[data-exode-upsell-track]');
    if (!track) return;
    const card = track.querySelector('.exode-upsell-card');
    const scrollAmt = card ? card.offsetWidth : track.clientWidth / 2;
    container.querySelector('[data-exode-upsell-prev]')?.addEventListener('click', () => track.scrollBy({ left: -scrollAmt, behavior: 'smooth' }));
    container.querySelector('[data-exode-upsell-next]')?.addEventListener('click', () => track.scrollBy({ left: scrollAmt, behavior: 'smooth' }));
  }

  function initStickyAtc(stickyEl) {
    const atcBtn = document.querySelector('[data-exode-add-to-cart]');
    if (!atcBtn) return;

    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting;
      stickyEl.classList.toggle('is-visible', show);
      stickyEl.hidden = !show;
    }, { threshold: 0 });

    observer.observe(atcBtn);

    stickyEl.querySelector(SELECTORS.stickyBtn)?.addEventListener('click', () => {
      const form = document.querySelector(SELECTORS.productForm);
      const qty = stickyEl.querySelector(SELECTORS.stickyQty);
      const mainQty = form?.querySelector('[name="quantity"]');
      if (qty && mainQty) mainQty.value = qty.value;
      atcBtn.click();
    });
  }

  function initProductForm(form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = getAddToCartButton(form, e.submitter);
      if (!btn || btn.disabled) return;
      const span = btn.querySelector('span') || btn;
      const original = span.textContent;
      btn.disabled = true;
      span.textContent = btn.dataset.labelAdding || 'Ajout…';
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!res.ok) throw new Error('fail');
        span.textContent = btn.dataset.labelAdded || 'Ajouté ✓';
        if (window.ExodeCart) {
          await window.ExodeCart.refresh();
          window.ExodeCart.open();
        }
        setTimeout(() => { span.textContent = original; btn.disabled = false; }, 2000);
      } catch {
        span.textContent = 'Erreur';
        setTimeout(() => { span.textContent = original; btn.disabled = false; }, 2000);
      }
    });
  }

  function findVariantByOptionIndex(productData, optionIndex, optionValue) {
    return (
      productData.variants.find((v) => v.options[optionIndex] === optionValue && v.available) ||
      productData.variants.find((v) => v.options[optionIndex] === optionValue)
    );
  }

  function findVariantByOption(productData, optionValue) {
    return findVariantByOptionIndex(productData, 0, optionValue);
  }

  function calcBundlePrices(unitCents, itemCount, compareAtCents) {
    const qty = itemCount === 0 ? 1 : itemCount;
    const sale = unitCents * qty;
    const compare = compareAtCents * qty;
    return { sale, compare: compare > sale ? compare : 0 };
  }

  function updateBundlePrices(container, productData, variant) {
    if (!variant) return;
    const moneyFormat = productData.money_format;

    container.querySelectorAll('[data-exode-bundle-offer]').forEach((offer) => {
      const itemCount = parseInt(offer.dataset.itemCount, 10) || 0;
      const { sale, compare } = calcBundlePrices(
        variant.price,
        itemCount,
        variant.compare_at_price || 0
      );

      const saleEl = offer.querySelector('[data-exode-bundle-price]');
      const compareEl = offer.querySelector('[data-exode-bundle-compare]');
      if (saleEl) saleEl.textContent = formatMoney(sale, moneyFormat);
      if (compareEl) {
        if (compare > sale) {
          compareEl.textContent = formatMoney(compare, moneyFormat);
          compareEl.classList.remove('exode-hidden');
        } else {
          compareEl.textContent = '';
          compareEl.classList.add('exode-hidden');
        }
      }
    });
  }

  function getBundlePriceVariant(container, productData) {
    const selected =
      container.querySelector('[data-exode-bundle-offer].is-selected') ||
      container.querySelector('[data-exode-bundle-offer]');
    const selects = selected?.querySelectorAll('[data-exode-bundle-select]');
    if (selects?.length) {
      const idx = parseInt(selects[0].dataset.optionIndex, 10) || 0;
      return findVariantByOptionIndex(productData, idx, selects[0].value);
    }
    const variantInput = document.querySelector('[data-exode-variant-id]');
    if (variantInput) {
      return productData.variants.find((v) => String(v.id) === variantInput.value);
    }
    return productData.variants[0];
  }

  function syncBundlePrices(container, productData) {
    const variant = getBundlePriceVariant(container, productData);
    if (variant) updateBundlePrices(container, productData, variant);
  }

  function initBundleOffers(container, productData) {
    const offers = container.querySelectorAll('[data-exode-bundle-offer]');
    const atcBtn = container.querySelector('[data-exode-bundle-atc]');
    if (!offers.length || !atcBtn) return;

    offers.forEach((offer) => {
      offer.querySelectorAll('select').forEach((sel) => {
        sel.addEventListener('click', (e) => e.stopPropagation());
        sel.addEventListener('change', () => {
          const idx = parseInt(sel.dataset.optionIndex, 10) || 0;
          const variant = findVariantByOptionIndex(productData, idx, sel.value);
          if (variant) {
            const variantInput = document.querySelector('[data-exode-variant-id]');
            if (variantInput && offer.classList.contains('is-selected')) {
              variantInput.value = variant.id;
            }
            syncBundlePrices(container, productData);
          }
        });
      });

      offer.addEventListener('click', (e) => {
        if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
        offers.forEach((o) => o.classList.remove('is-selected'));
        offer.classList.add('is-selected');
      });
    });

    atcBtn.addEventListener('click', async () => {
      const selected = container.querySelector('[data-exode-bundle-offer].is-selected') || offers[0];
      const selects = selected.querySelectorAll('[data-exode-bundle-select]');
      const root = window.Shopify?.routes?.root || '/';

      atcBtn.disabled = true;
      const label = atcBtn.textContent;
      atcBtn.textContent = 'Ajout…';

      try {
        const items = [];
        selects.forEach((sel) => {
          const idx = parseInt(sel.dataset.optionIndex, 10) || 0;
          const variant = findVariantByOptionIndex(productData, idx, sel.value);
          if (variant) {
            const existing = items.find((i) => i.id === variant.id);
            if (existing) existing.quantity += 1;
            else items.push({ id: variant.id, quantity: 1 });
          }
        });

        if (items.length === 0) {
          const count = parseInt(selected.dataset.itemCount, 10) || 1;
          const variantInput = document.querySelector('[data-exode-variant-id]');
          if (variantInput) items.push({ id: parseInt(variantInput.value, 10), quantity: count });
        }

        if (items.length === 1) {
          const fd = new FormData();
          fd.append('id', String(items[0].id));
          fd.append('quantity', String(items[0].quantity));
          await fetch(`${root}cart/add.js`, { method: 'POST', body: fd });
        } else {
          await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          });
        }

        atcBtn.textContent = 'Ajouté ✓';
        if (window.ExodeCart) {
          await window.ExodeCart.refresh();
          window.ExodeCart.open();
        }
        setTimeout(() => { atcBtn.textContent = label; atcBtn.disabled = false; }, 2000);
      } catch {
        atcBtn.textContent = 'Erreur';
        setTimeout(() => { atcBtn.textContent = label; atcBtn.disabled = false; }, 2000);
      }
    });

    syncBundlePrices(container, productData);
  }

  function initProgressBars() {
    const fills = document.querySelectorAll('[data-exode-progress-fill]');
    if (!fills.length) return;

    const animate = () => {
      fills.forEach((fill) => {
        const target = fill.style.width;
        if (!target) return;
        fill.style.setProperty('--exode-progress-width', target);
        fill.style.removeProperty('width');
        requestAnimationFrame(() => fill.classList.add('is-animated'));
      });
    };

    if ('IntersectionObserver' in window) {
      const container = document.querySelector('[data-exode-progress-bars]');
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            setTimeout(animate, 2000);
            observer.disconnect();
          }
        },
        { threshold: 0.2 }
      );
      observer.observe(container || fills[0]);
    } else {
      setTimeout(animate, 2000);
    }
  }

  function initPackOptions(form) {
    const groups = form.querySelectorAll('[data-exode-pack-option]');
    if (!groups.length) return;

    groups.forEach((group) => {
      group.querySelectorAll('[data-exode-pack-input]').forEach((input) => {
        input.addEventListener('change', () => {
          group.classList.remove('is-invalid');
          const err = group.querySelector('[data-exode-pack-error]');
          if (err) err.hidden = true;
        });
      });
    });

    form.addEventListener('submit', (e) => {
      let valid = true;
      groups.forEach((group) => {
        const requiredInput = group.querySelector('[data-exode-pack-input][required]');
        if (!requiredInput) return;
        const name = requiredInput.name;
        const checked = group.querySelector(`[data-exode-pack-input][name="${CSS.escape(name)}"]:checked`);
        const err = group.querySelector('[data-exode-pack-error]');
        if (!checked) {
          valid = false;
          group.classList.add('is-invalid');
          if (err) err.hidden = false;
        }
      });
      if (!valid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const firstInvalid = form.querySelector('.exode-pack-options__group.is-invalid');
        firstInvalid?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }

  function initDeferredVideo() {
    document.querySelectorAll('[data-exode-deferred-video]').forEach((wrapper) => {
      const playBtn = wrapper.querySelector('[data-exode-video-play]');
      const template = wrapper.querySelector('[data-exode-video-template]');
      if (!playBtn || !template) return;

      playBtn.addEventListener('click', () => {
        const iframe = template.content.cloneNode(true).querySelector('iframe');
        if (!iframe) return;
        playBtn.remove();
        wrapper.appendChild(iframe);
      });
    });
  }

  function initFaq(container) {
    const items = container.querySelectorAll('.faq-content__wrapper');
    items.forEach((item) => {
      const btn = item.querySelector('.faq-content__question');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        items.forEach((i) => {
          i.classList.remove('is-open');
          i.querySelector('.faq-content__question')?.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll(SELECTORS.gallery).forEach(initGallery);

    const productJson = document.getElementById('ExodeProductJson');
    if (productJson) {
      try {
        const data = JSON.parse(productJson.textContent);
        document.querySelectorAll(SELECTORS.variantPicker).forEach((el) => initVariantPicker(el, data));
        document.querySelectorAll('[data-exode-bundle]').forEach((el) => initBundleOffers(el, data));
        const stickyVariant = document.querySelector(SELECTORS.stickyVariant);
        if (stickyVariant && !document.querySelector(SELECTORS.variantPicker)) {
          stickyVariant.addEventListener('change', () => {
            const v = data.variants.find((x) => String(x.id) === stickyVariant.value);
            if (v) {
              document.querySelector(SELECTORS.variantInput).value = v.id;
              document.querySelector(SELECTORS.price).textContent = v.price_formatted;
            }
          });
        }
      } catch { /* ignore */ }
    }

    document.querySelectorAll('[data-exode-quantity]').forEach(initQuantity);
    document.querySelectorAll('[data-exode-collapsible-accordions]').forEach(initCollapsibleAccordions);
    document.querySelectorAll('[data-exode-upsell]:not([data-exode-upsell-fetch])').forEach(initUpsell);
    initUpsellFetch();
    document.querySelectorAll('[data-exode-faq]').forEach(initFaq);
    document.querySelectorAll('[data-exode-reviews-slider], [data-exode-related-slider]').forEach((c) => {
      const track = c.querySelector('[data-exode-slider-track]');
      c.querySelector('[data-exode-slider-prev]')?.addEventListener('click', () => track?.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' }));
      c.querySelector('[data-exode-slider-next]')?.addEventListener('click', () => track?.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' }));
    });

    const sticky = document.querySelector(SELECTORS.stickyAtc);
    if (sticky) initStickyAtc(sticky);

    const form = document.querySelector(SELECTORS.productForm);
    if (form) {
      initPackOptions(form);
      initProductForm(form);
    }

    initProgressBars();
    initDeferredVideo();

    document.querySelectorAll('[data-exode-related-fetch]').forEach((section) => {
      if (section.dataset.loaded === 'true') return;
      fetch(section.dataset.url).then((r) => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const track = section.querySelector('[data-exode-slider-track]');
        const newTrack = doc.querySelector('[data-exode-slider-track]');
        if (track && newTrack?.innerHTML.trim()) track.innerHTML = newTrack.innerHTML;
        section.dataset.loaded = 'true';
      }).catch(() => {});
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
